import { useCallback, useState } from 'react';
import { FormikHelpers } from 'formik';

import { initialValues, validationSchema } from './constants';
import { LogicProps } from './types';
import { CDError } from '../../utils/error';

type FormValues = typeof initialValues;

const useLogic = ({ login }: LogicProps) => {
  const [showModal, setShowModal] = useState(false);
  const [passwordVisability, setPasswordVisability] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleSubmit = useCallback(
    async (
      values: FormValues,
      { setErrors, setFieldError }: FormikHelpers<FormValues>,
    ) => {
      try {
        await login(values);
      } catch (error) {
        if (error instanceof CDError) {
          if (error.fields) {
            setErrors(error.fields);
          } else {
            setFieldError('password', error.message);
          }
        } else {
          throw error;
        }
      }
    },
    [login],
  );

  const togglePasswordVisability = useCallback(() => {
    setPasswordVisability(!passwordVisability);
  }, [passwordVisability, setPasswordVisability]);

  return {
    handleSubmit,
    initialValues,
    validationSchema,
    showModal,
    handleCloseModal,
    handleOpenModal,
    passwordVisability,
    togglePasswordVisability,
  };
};

export default useLogic;
